module.exports = __webpack_public_path__ + "img/salami.97e5b793.png";